export default "__VITE_ASSET__e6a2a835__"